"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStylesProvider = void 0;
const react_1 = require("@emotion/react");
const react_2 = __importDefault(require("react"));
const GlobalStylesProvider = ({ children }) => {
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(react_1.Global, { styles: (0, react_1.css) `
          @import url('https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap');

          .pixelart {
            image-rendering: pixelated;
          }
        ` }),
        children));
};
exports.GlobalStylesProvider = GlobalStylesProvider;
//# sourceMappingURL=GlobalStylesProvider.js.map